import EmojiRatingComponent from '../custom_components/EmojiRating'
import { Field, FieldProps } from 'formik'
import { FormikFieldProps } from './FieldProps'
interface FromikEmojiRatingProps {
  currentlySelected?: number
  disabled: boolean
}

type EmojiRatingProps = FormikFieldProps & FromikEmojiRatingProps & { [key: string]: unknown }

const EmojiRating = ({ name, validate, ...props }: EmojiRatingProps): JSX.Element => (
  <Field name={name} validate={validate}>
    {({ field: { value }, form: { setFieldValue } }: FieldProps) => (
      <EmojiRatingComponent
        currentlySelected={value}
        onEmojiClicked={(v) => {
          setFieldValue(name, !isNaN(v) ? v : '')
        }}
        {...props}
      />
    )}
  </Field>
)

export default EmojiRating
